import { all, put, takeLatest } from 'redux-saga/effects'
import {
  CreateScheduledNotificationRequest,
  DeleteScheduledNotificationRequest,
  ScheduledNotificationsActionTypes,
  UpdateScheduledNotificationRequest,
} from './types'
import {
  createScheduledNotificationFailure,
  createScheduledNotificationSuccess,
  deleteScheduledNotificationFailure,
  deleteScheduledNotificationSuccess,
  getScheduledNotificationsFailure,
  getScheduledNotificationsSuccess,
  updateScheduledNotificationFailure,
  updateScheduledNotificationSuccess,
} from './action'
import { apiV2, SdkResponse, wrapResponse } from '../../repositories/repository'

// Validation errors come back as a list of messages, typed as a single string
const toErrorMessage = (error: string | string[]): string => (Array.isArray(error) ? error.join('. ') : error)

function* handleGetScheduledNotifications() {
  const apiCall = apiV2.scheduledNotifications.findAll.bind(apiV2.scheduledNotifications)
  const res = (yield wrapResponse(apiCall())) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(getScheduledNotificationsSuccess(res.data))
  } else {
    yield put(getScheduledNotificationsFailure(toErrorMessage(res.error)))
  }
}

function* handleCreateScheduledNotification({ data }: CreateScheduledNotificationRequest) {
  const apiCall = apiV2.scheduledNotifications.create.bind(apiV2.scheduledNotifications)
  const res = (yield wrapResponse(apiCall(data))) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(createScheduledNotificationSuccess())
    yield handleGetScheduledNotifications()
  } else {
    yield put(createScheduledNotificationFailure(toErrorMessage(res.error)))
  }
}

function* handleUpdateScheduledNotification({ id, data }: UpdateScheduledNotificationRequest) {
  const apiCall = apiV2.scheduledNotifications.update.bind(apiV2.scheduledNotifications)
  const res = (yield wrapResponse(apiCall(id, data))) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(updateScheduledNotificationSuccess())
    yield handleGetScheduledNotifications()
  } else {
    yield put(updateScheduledNotificationFailure(toErrorMessage(res.error)))
  }
}

function* handleDeleteScheduledNotification({ id }: DeleteScheduledNotificationRequest) {
  const apiCall = apiV2.scheduledNotifications.delete.bind(apiV2.scheduledNotifications)
  const res = (yield wrapResponse(apiCall(id))) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(deleteScheduledNotificationSuccess())
    yield handleGetScheduledNotifications()
  } else {
    yield put(deleteScheduledNotificationFailure(toErrorMessage(res.error)))
  }
}

function* scheduledNotificationsSaga() {
  yield all([
    takeLatest(ScheduledNotificationsActionTypes.GET_NOTIFICATIONS_REQUEST, handleGetScheduledNotifications),
    takeLatest(ScheduledNotificationsActionTypes.CREATE_NOTIFICATION_REQUEST, handleCreateScheduledNotification),
    takeLatest(ScheduledNotificationsActionTypes.UPDATE_NOTIFICATION_REQUEST, handleUpdateScheduledNotification),
    takeLatest(ScheduledNotificationsActionTypes.DELETE_NOTIFICATION_REQUEST, handleDeleteScheduledNotification),
  ])
}

export default scheduledNotificationsSaga
